// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .image-actions *[data-v-4f337e7a] {\n  margin: 5px\n}\n", ""]);
// Exports
module.exports = exports;
